module.exports = __webpack_public_path__ + "static/img/zskyj_jcjg_icon.png";